mutation RunDuplicateChecker($id: ID!) {
  runDuplicateChecker(input: { id: $id }) {
    success
  }
}
